import type { CSSProperties } from "react";
import type { HeaderImageSettings } from "../types";

export function headerImageStyle(settings: HeaderImageSettings): CSSProperties {
  const style: Record<string, string> = {
    "--header-desktop-x": `${settings.desktopX}%`,
    "--header-desktop-y": `${settings.desktopY}%`,
    "--header-mobile-x": `${settings.mobileX}%`,
    "--header-mobile-y": `${settings.mobileY}%`,
  };

  if (settings.image.trim()) style["--header-image"] = `url(${JSON.stringify(settings.image.trim())})`;
  return style as CSSProperties;
}
